import script from "./BaseForm.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseForm.vue?vue&type=script&setup=true&lang=js"

import "./BaseForm.vue?vue&type=style&index=0&id=9f0c0ea0&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f0c0ea0"]])

export default __exports__